/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Unpin_From_SidebarInputs */

const en_unpin_from_sidebar = /** @type {(inputs: Unpin_From_SidebarInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Unpin ${i?.name} from the sidebar`)
};

/**
* | output |
* | --- |
* | "Unpin {name} from the sidebar" |
*
* @param {Unpin_From_SidebarInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const unpin_from_sidebar = /** @type {((inputs: Unpin_From_SidebarInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Unpin_From_SidebarInputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_unpin_from_sidebar(inputs)
});